import React from 'react';

import map from 'lodash/map';
import { observer } from 'mobx-react';
import { Checkbox } from '@bringg/react-components';
import { SharingMode as SharingModeIds } from '@bringg/types';

import { Select, Option } from '../../../components';
import { SHARING_MODES } from './sharing-mode.consts';
import { Translate } from '../../../translation';
import TagMerchantConfiguration from '../../../stores/tag-merchant-configurations/tag-merchant-configuration';
import MerchantConfiguration from '../../../stores/merchant-configurations/domain-objects/merchant-configuration';
import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';

interface Props {
	configuration: MerchantConfiguration | TagMerchantConfiguration;
}

const SharingMode = (props: Props) => {
	const {
		sharingMode,
		updateSharingMode,
		sendSharedLocationWebhookOnContactsMissing,
		updateSendSharedLocationWebhookOnContactsMissing
	} = props.configuration;

	const isSendSharedLocationWebhookOnContactsMissingFFEnabled = useHasFeatureFlag(
		'share_location_via_webhook_when_no_contacts'
	);

	return (
		<div className="sharing-mode">
			<div className="title">
				<Translate text="CUSTOMER_CONFIGURATION_VIEW.SHARING_WITH_CUSTOMER" />
			</div>
			<Select className="sharing-mode-select" value={sharingMode} onSelect={updateSharingMode}>
				{map(SHARING_MODES, ({ value, label }) => (
					<Option key={value} value={value}>
						{label}
					</Option>
				))}
			</Select>
			{isSendSharedLocationWebhookOnContactsMissingFFEnabled && sharingMode !== SharingModeIds.WEBHOOKS_ONLY ? (
				<div className="send-shared-location-webhook-on-contacts-missing">
					<Checkbox
						checked={sendSharedLocationWebhookOnContactsMissing}
						onChange={({ target }) => updateSendSharedLocationWebhookOnContactsMissing(target.checked)}
						data-test-id="send-shared-location-webhook-on-contacts-missing"
					>
						<Translate text="CUSTOMER_CONFIGURATION_VIEW.SEND_SHARED_LOCATION_WEBHOOK_ON_CONTACTS_MISSING" />
					</Checkbox>
				</div>
			) : null}
		</div>
	);
};

export default observer(SharingMode);
